

import { memo } from 'react';
import { Link } from 'react-router-dom';


export default memo(function EFASLoginButton(props: { className?: string }) {
    // both levels are encoded so the map share state in the query survives Keycloak and Django each decoding once
    const redirect_uri = `${window.location.origin}/api/sso/login/oidc/?next=${encodeURIComponent(window.location.href)}`;
    const login_url = `${import.meta.env.VITE_KEYCLOAK_LOGIN_URL}?client_id=${import.meta.env.VITE_KEYCLOAK_CLIENT}&response_type=code&scope=openid%20email%20profile&redirect_uri=${encodeURIComponent(redirect_uri)}`;

    return <Link id='login-button' className={`efas-account-menu efas-account-menu-login text-nowrap ${props.className || ""} px-4 py-1 `} to={login_url}>LOG IN</Link>;
});

